<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      class="modal"
      :title="$t('Prompt')"
      :visible="true"
      width="30%"
      @close="cancel"
    >
      <!-- <div class="dialog-title" slot="title">
        {{ $t('prompt') }}
      </div> -->
      <div style="margin-bottom: 10px;"><span class="pointer template-file" @click="downloadTemplate">{{ $t('templateFile') }}</span></div>
      <span v-if="text">{{ text }}</span>
      <div class="upload-wrap" style="margin: 20px 0;">
        <div class="file-name">{{ fileName }}</div>
          <el-button class="blue-btn"><upload @change="fileChange" style="display: inline-block; width: 100%">{{ $t('browse') }}</upload></el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="blue-btn" @click="upload">{{ $t('import') }}</el-button>
        <el-button class="gray-btn" @click="cancel">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import upload from './upload'
import { exportInfoTemplate } from '../api/importAndExport'

export default {
  name: 'uploadModal',
  components: { upload },
  props: {
    type: {
      type: Number,
      default: 1, // 1为Device.xlsx;  2为Zone.xlsx";  3为Advance.xlsx
    },
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      file: null,
      fileName: ''
    }
  },
  methods: {
    upload () {
      this.$emit('upload', this.file)
    },
    cancel () {
      this.$emit('close')
    },
    fileChange (file) {
      this.file = file || null
      this.fileName = file.name || ''
    },
    downloadTemplate () {
      // http://localhost:8080/#/exportInfo/downloadTemplet?type=1"
      window.location.href = "/en/exportInfo/downloadTemplet?type=" + this.type
      // exportInfoTemplate({
      //   type: this.type
      // }).then(res => {
      // })
    }
  }
}
</script>
<style lang="less">
  .upload-wrap {
    margin-top: 10px;
    position: relative;
    .file-name {
      display: inline-block;
      width: calc(100% - 85px);
      vertical-align: bottom;
      margin-right: 10px;
      height: 30px;
      border: 1px solid #ccc;
      line-height: 30px;
    }
  }
  .template-file {
    color: @color-blue;
    font-style: oblique;
    text-decoration: underline;
  }
</style>
